import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Table, Column, AutoSizer } from 'react-virtualized';

class UserAdminTable extends Component {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect({ index }) {
    this.props.onUserClick(this.props.users.get(index));
  }

  render() {
    const { users, onNewClick } = this.props;
    return (
      <div className='userTable'>
        <div className='tableContainer'>
          <AutoSizer>
            {({ height, width }) => (
              <Table
                height={height}
                width={width}
                headerHeight={45}
                rowHeight={35}
                className='mainTable'
                onRowClick={this.onSelect}
                rowGetter={({ index }) => users.get(index)}
                rowCount={users.size}
                scrollingResetTimeInterval={50}
              >
                <Column
                  width={200}
                  flexGrow={1}
                  label='Email'
                  dataKey='email'
                />
              </Table>
            )}
          </AutoSizer>
        </div>
        <Button bsStyle='primary' bsSize='large' onClick={onNewClick}>Add New User</Button>
      </div>
    );
  }
}

export default UserAdminTable;
